import { graphql } from '@apollo/client/react/hoc'

import { getBrandConnectedAccounts } from 'utils/transformations/accounts'

import { graphene } from 'graphql/tags'

export const MINIMUM_CHARACTERS_QUERY = 2

const assignRetailerAccountQuery = graphene`#graphql
  query AssignRetailerAccountQuery($searchFilter: String) {
    connectedAccounts(filterBy: { displayName: $searchFilter }) {
      edges {
        node {
          ... on RetailerAccount {
            id
            displayName
            locations(filterBy: { primary: true }) {
              edges {
                node {
                  id
                  state
                  city
                }
              }
            }
          }
        }
      }
    }
  }
`

const assignPublicRetailerAccountQuery = graphene`#graphql
  query AssignPublicRetailerAccountQuery(
    $searchFilter: String
    $userEmail: String
    $ids: [ID]
  ) {
    retailers(
      filterBy: { displayName: $searchFilter, userEmail: $userEmail, ids: $ids }
      first: 50
    ) {
      edges {
        node {
          ... on PublicRetailerAccount {
            id
            name
            isConnected
            isPro
            locations(filterBy: { primary: true }) {
              edges {
                node {
                  city
                  state
                  address1
                  address2
                  zip
                  country
                }
              }
            }
          }
        }
      }
    }
  }
`

export const connectedRetailersData = ({
  data: { connectedAccounts, loading, error },
}) => ({
  retailers:
    !loading && !error && connectedAccounts
      ? getBrandConnectedAccounts(connectedAccounts)
      : [],
  publicAccountsQueryLoading: loading,
})

export const withConnectedRetailers = graphql(assignRetailerAccountQuery, {
  options: ({ retailerSearchText }) => ({
    variables: { searchFilter: retailerSearchText },
  }),
  props: connectedRetailersData,
  skip: ({ retailerSearchText }) =>
    retailerSearchText.length < MINIMUM_CHARACTERS_QUERY,
})

export const publicRetailersData = ({
  data: { retailers, loading, error },
}) => ({
  retailers:
    !loading && !error && retailers ? getBrandConnectedAccounts(retailers) : [],
  publicAccountsQueryLoading: loading,
})

export const withPublicRetailers = graphql(assignPublicRetailerAccountQuery, {
  options: ({ retailerSearchText, retailerContactEmail, retailerIds }) => ({
    fetchPolicy: 'no-cache',
    variables: {
      searchFilter: retailerSearchText,
      userEmail: retailerContactEmail,
      ids: retailerIds,
    },
  }),
  props: publicRetailersData,
  skip: ({ retailerSearchText }) =>
    retailerSearchText.length < MINIMUM_CHARACTERS_QUERY,
})
